<template>
    <div id="player">
        <div class="play-pause">
            <img v-if="playing" src="../../assets/pause-button.png" width="100%" @click="onPause"/>
            <img v-if="!playing" src="../../assets/play-button.png" width="100%" @click="onPlay"/>
        </div>
        <div class="progress-container">
            <div class="text-container left-text-container">
                <p class="text">12 AM</p>
            </div>
            <div class="text-container center-text-container">
                <p class="text">12 PM</p>
            </div>
            <div class="text-container right-text-container">
                <p class="text">12 AM</p>
            </div>
            <div class="progress-bar"></div>
            <div class="progress-bar progress-bar-active" :style="{'width': 'calc(' + progress + '%' + ' + 2px'}"></div>
            <div v-for="(tick, index) in ticks"
                 :class="{'tick': true, 'tick-big': isBigTick(index), 'tick-small': !isBigTick(index)}"
                 :style="{'left': getTickX(index) + '%', 'bottom': '40%'}">
            </div>
            <div v-for="(tick, index) in ticks" class="tick-button"
                 :style="{'left': getTickX(index) - space / 2 + '%', 'top': '0', 'width': space + '%'}"
                 @click="onTickClick(tick, index)"></div>
        </div>
    </div>
</template>

<script>

    const TICK_PLAY_INTERVAL = 1; // secs

    export default {
        name: "player",
        props: {
            ticks: {
                type: Array,
                required: true
            },
            stopTick: {
                type: Number,
                required: true
            }
        },
        data() {
            return {
                playing: false,
                space: null,
                progress: 0,
                playInterval: null,
                progressIncrementPerCycle: 0
            }
        },
        methods: {
            onPlay() {
                this.play();
            },
            onPause() {
                this.pause();
            },
            play() {
                var self = this;
                this.playing = true;
                this.playInterval = setInterval(function () {
                    self.progress += self.progressIncrementPerCycle;
                    if (self.progress >= 100) {
                        self.progress = 0;
                        self.$emit("onTickClick", self.ticks[0]);
                    } else {
                        for (let i = 0; i < self.checkpoints.length; i++) {
                            let checkpoint = self.checkpoints[i];
                            if (Math.abs(checkpoint - self.progress) < 0.1) {
                                self.$emit("onTickClick", self.ticks[i]);
                                if (i >= self.stopTick) {
                                    self.progress = 0;
                                    self.$emit("onTickClick", self.ticks[0]);
                                    break;
                                }
                                break;
                            }
                        }
                    }
                }, 500);
            },
            pause() {
                this.playing = false;
                clearInterval(this.playInterval);
            },
            onTickClick(tick, index) {
                this.pause();
                this.progress = this.getTickX(index);
                this.$emit("onTickClick", tick);
            },
            isBigTick(index) {
                if (index == 0 || index == 12 || index == this.ticks.length - 1)
                    return true;
                return false;
            },
            getTickX(tickIndex) {
                return this.space * tickIndex;
            },
            reset() {
                this.pause();
                this.progress = 0;
            }
        },
        computed: {
            checkpoints() {
                var points = [];
                for (let i = 0; i < this.ticks.length; i++) {
                    points.push(this.getTickX(i));
                }
                return points;
            }
        },
        beforeDestroy() {
            clearInterval(this.playInterval);
        },
        mounted() {
            this.space = 100 / (this.ticks.length - 1);
            this.progressIncrementPerCycle = this.space / (TICK_PLAY_INTERVAL * 2);
        }
    }

</script>

<style scoped>

    #player {
        position: relative;
        width: 100%;
        height: 100%;
    }

    .play-pause {
        position: absolute;
        left: -5px;
        top: 0%;
        width: 5%;
        height: 100%;
        cursor: pointer;
    }

    .play-pause img {
        position: absolute;
        top: 30%;
        left: 0;
        bottom: 0;
        margin: auto;
    }

    .progress-container {
        width: 90%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 6%;
    }

    .text {
        width: 100%;
        height: 100%;
        color: rgb(31, 50, 62);
    }

    .text-container {
        position: absolute;
        width: 20%;
        height: 40%;
        font-size: 15px;
        font-family: 'Digital-Serial-Bold';
    }

    .left-text-container {
        left: -5px;
        top: -2px;
        text-align: left;
    }

    .center-text-container {
        left: 40%;
        top: -2px;
        text-align: center;
    }

    .right-text-container {
        right: -2px;
        top: -2px;
        text-align: right;
    }

    .progress-bar {
        position: absolute;
        background-color: rgb(31, 50, 62);
        width: calc(100% + 2px);
        height: 10%;
        top: 30%;
        bottom: 0;
        left: 0;
        margin: auto;
    }

    .progress-bar-active {
        z-index: 2;
        background-color: rgba(76, 99, 121, 1);
        transition: width .5s;
    }

    .tick {
        position: absolute;
        background-color: rgb(31, 50, 62);
        width: 2px;
    }

    .tick-small {
        height: 8%;
    }

    .tick-big {
        height: 18%;
    }

    p {
        margin: 0;
    }

    .tick-button {
        height: 100%;
        position: absolute;
        z-index: 4;
    }

</style>



// WEBPACK FOOTER //
// src/components/player/Player.vue